import React from 'react';

import RequestAccessForm from '@shared/components/RequestAccessForm';

import styles from './styles.module.css';

const HeroPortalForm: React.FC = () => (
  <aside
    className={styles.card}
    aria-label="Request access to the ThredUp Client Portal"
  >
    <RequestAccessForm
      variant="hero"
      maxColleagues={1}
      colleagueMode="toggle"
    />
  </aside>
);

export default HeroPortalForm;
